
export class Global{
     static sharedLink = "https://share.creasoft.uk?";
}
